import { IVersionUpdate } from './IAppUpdate.interface';

export interface IMyApp {
  id?: string;
  versionsToUpdate?: IVersionUpdate[];
  appId: string;
  appName: string;
  appVersion: string;
  appVersionId: string;
  appmarketAppId: string;
  licensesData: {
    licensesAvailable: number;
    licensesUsed: number;
  };
  price: number;
  pricingModel: string;
  pricingModelId: string;
}
